import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { downloadInvoice } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      noImageUrl: getNoImageUrl(),
      isDownloading: localState.status === "Downloading",
      isEditMode: state.isEditMode,
      isAddCommentButtonHidden: true,
      orderSummary: localState.orderSummary!
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onDownload: () => dispatch(downloadInvoice(getEntityRef(props)))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
